export const CHECKOUT_PATH = "/hotels/book";
